"use strict";

exports.__esModule = true;
exports.withChartCard = withChartCard;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("./ChartCard");
var _useUiDesign2 = require("../../../Theme/UiDesign/useUiDesign");
var _excluded = ["elementProps"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Wrap a widget Element so it renders inside a ChartCard and receives the
 * width and height the card leaves for it. `getCardProps(props)` returns the
 * card's title/subtitle/unit/legend; its optional `elementProps` are merged
 * into the wrapped Element's props (used to hand a chart its own title so it
 * does not draw a second one).
 */
function withChartCard(Element, getCardProps) {
  if (getCardProps === void 0) {
    getCardProps = function getCardProps() {
      return {};
    };
  }
  var Carded = function Carded(props) {
    var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
      modern = _useUiDesign.modern;
    if (!modern) {
      // Legacy UI: the widget renders as it always did, without a card.
      return /*#__PURE__*/_react["default"].createElement(Element, props);
    }
    var _ref = getCardProps(props) || {},
      elementProps = _ref.elementProps,
      card = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_ChartCard.ChartCard, _extends({
      width: props.width,
      height: props.height,
      backgroundColor: props.backgroundColor
    }, card), function (_ref2) {
      var width = _ref2.width,
        height = _ref2.height;
      return /*#__PURE__*/_react["default"].createElement(Element, _extends({}, props, elementProps, {
        width: width,
        height: height
      }));
    });
  };
  Carded.displayName = "WithChartCard(" + (Element.displayName || Element.name || "Element") + ")";
  return Carded;
}